
<script>
export default {
  name: 'zr-tab',
  props: ['title', 'titleSlot', 'disabled'],
  render() {
    return (
      <div class="zr-tabpanel" role="tabpanel">
        {this.$slots.default}
      </div>
    );
  }
};
</script>

<style lang="scss">

  .zr-tabpanel {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 50px;
  }
  .zr-tabs.fixed {
    .zr-tabpanel {
      margin-top: 70px;
    }
  }
</style>